<template>
    <div>
        <div class="block-container">
            <div class="content-caption dashed bg-white">
                <span>请求信息</span>
            </div>
            <div class="form-single" style="overflow:visible">
                <div class="title">请求单号</div>
                <div class="content">
                    <span>{{servcReqVoucher.no}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务号</div>
                <div class="content">
                    <span>{{servcReqVoucher.svcNo || '无'}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">创建时间</div>
                <div class="content">
                    <span>{{servcReqVoucher.ts}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">请求时间</div>
                <div class="content">
                    <span>{{servcReqVoucher.requestTime}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">预约上门时间</div>
                <div class="content">
                    <span>{{servcReqVoucher.planTime}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">要求响应时间</div>
                <div class="content">
                    <span>{{servcReqVoucher.yqRspTimeMi}} &nbsp; 分钟</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">要求到达时长</div>
                <div class="content">
                    <span>{{servcReqVoucher.yqArriveTimeMi}} &nbsp; 分钟</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">要求完成时长</div>
                <div class="content">
                    <span>{{servcReqVoucher.yqRepairedTimeMi}} &nbsp; 分钟</span>
                </div>
            </div>
            <div class="form-single" v-if="servcReqVoucher.cancelled">
                <div class="title">取消原因</div>
                <div class="content">
                    <span>{{servcReqVoucher.cancelCause || '无'}}</span>
                </div>
            </div>
            <div class="form-single" v-if="servcReqVoucher.servicerAcceptState == -1"><!--已拒绝-->
                <div class="title">拒绝原因</div>
                <div class="content">
                    <span>{{servcReqVoucher.servicerRefuseDesc || '无'}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">请求描述</div>
                <div class="content">
                    <span>{{servcReqVoucher.requestDesc}}</span>
                </div>
            </div>
            <div class="content-caption dashed bg-white">
                <span>买家信息</span>
            </div>
            <div class="form-single" style="">
                <div class="title">买家名称</div>
                <div class="content">
                    <span>{{servcReqVoucher.buyerName}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">机构名称</div>
                <div class="content">
                    <span>{{servcReqVoucher.buyerShopName}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">详细地址</div>
                <div class="content">
                    <span>{{servcReqVoucher.buyerShopAddr}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系人</div>
                <div class="content">
                    <span>{{servcReqVoucher.buyerShopUserName}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系电话</div>
                <div class="content">
                    <span>{{servcReqVoucher.buyerShopContactTel}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">故障描述</div>
                <div class="content">
                    <span>{{servcReqVoucher.troubleDesc}}</span>
                </div>
            </div>

            <!-- 服务请求单附件信息 -->
            <swb-servc-req-voucher-file-detail :reqVoucherId="reqVoucherId"></swb-servc-req-voucher-file-detail>

            <div class="content-caption dashed bg-white">
                <span>服务信息</span>
            </div>
            <div class="form-single">
                <div class="title">服务项</div>
                <div class="content">
                    <span>{{servcReqVoucher.title}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">工单信息</div>
                <div class="content" style="width: auto">
                    <div v-if="servcWorkVoucherList.length > 0">
                        <el-table :data="servcWorkVoucherList" border>
                            <el-table-column label="服务工单" width="180">
                                <template slot-scope="scope">
                                    <span> <a class="swb-btn-link" @click="returnServcWorkVoucher(scope.row.no)">{{scope.row.no}}</a></span>
                                </template>
                            </el-table-column>
                            <el-table-column label="紧急状态" prop="emgLevel" width="80" align="center">
                                <template slot-scope="rows">
                                    <span :class="rows.row.emgLevel == 0 ? 'font-green' : rows.row.emgLevel == 1 ? 'font-orange' : 'font-red'">{{emgLevelMap[rows.row.emgLevel]}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" label="工单状态" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.invalid" class="font-red">已作废</span>
                                    <span v-else-if="scope.row.closed" class="font-red">已关闭</span>
                                    <span v-else="scope.row.closed" class="font-green">{{scope.row.status}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="toDoorTime" label="上门时间" width="150"></el-table-column>
                            <el-table-column label="服务完成时间">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.finished">{{scope.row.finishTime}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <span class="swb-btn swb-btn-link" v-if="scope.row.tmpNo != null" @click="showDeviceRepairRec(scope.row.tmpNo)">维保记录</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed bg-white">
                <span>服务商信息</span>
            </div>
            <div class="form-single">
                <div class="title">受理时间</div>
                <div class="content">
                    <span>{{servcReqVoucher.acceptTime}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">网点名称</div>
                <div class="content" v-if="servicerCom != null && servicerCom.shopFlag">
                    <span>{{servicerCom.name}}</span>
                </div>
            </div>
            <div class="form-single">
                <div class="title">网点地址</div>
                <div v-if="servicerCom != null">
                    <div class="content" v-if="servicerCom.street == null && servicerCom.shopFlag">
                        <span>{{servicerCom.regionName}}</span>
                    </div>
                    <div class="content" v-else>
                        <span>{{servicerCom.regionName}}{{servicerCom.street}}</span>
                    </div>
                </div>

            </div>
            <div class="form-single">
                <div class="title">网点联系人</div>
                <div v-if="servicerCom != null">
                    <div class="content" v-if="servicerCom.shopFlag">
                        <span>{{servicerCom.contactName}}</span>
                    </div>
                </div>

            </div>
            <div class="form-single">
                <div class="title">网点联系电话</div>
                <div v-if="servicerCom != null">
                    <div class="content" v-if="servicerCom.shopFlag">
                        <span>{{servicerCom.contactTel}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openDeviceRepairRecDlg } from '../workVoucher/showDetailDlg'
    //
    import servicerApi from '../../api/servicer'
    import servcDelivApi from '../../api/servcDeliv'
    import servcDisptApi from '../../api/servcDispt'
    //
    import SwbServcReqVoucherFileDetail from './ServcReqVoucherFileDetail';
    Vue.regist(SwbServcReqVoucherFileDetail);

    export default{
        name: 'swb-servc-req-voucher-look',
        desc: '服务请求单查看',
        props: ['id'],
        data: function () {
            return {
                servcReqVoucher: {
                    status: null,
                },
                servcOrderItem: {},
                servcWorkVoucherList: [],
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                status: null,
                servicerCom: {},
                //
                reqVoucherId: null
            }
        },
        created: function () {
            this.reqVoucherId = this.id;
            //
            this.searchServcReqVoucher();
        },
        methods: {
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(tmpNo);
            },
            searchServcReqVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let loading = MsgBox.loading();
                servcDisptApi.getServcReqVoucher(postData, function (result) {
                    if(result.type == "info") {
                        let servcReqVoucher = result.data;
                        if(!Utils.isNoB(servcReqVoucher.servicerComId)) {
                            self.searchServicer(servcReqVoucher.servicerComId)
                        }
                        if(servcReqVoucher.srcMerchantId != null) {
                            servcReqVoucher.status = "服务有效"
                        }
                        if(servcReqVoucher.dstServicerAssigned) {
                            servcReqVoucher.status = "确定服务商"
                        }
                        if(servcReqVoucher.accepted) {
                            servcReqVoucher.status = "服务商受理"
                        }
                        self.searchServcWorkVoucher(self.id);
                        self.servcReqVoucher = servcReqVoucher;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                })
            },
            searchServicer: function (servicerComId) {
                let self = this;
                let postData = {};
                postData.comId = servicerComId;
                servicerApi.getServicerCom(postData, function (result) {
                    if(result.type == "info") {
                        self.servicerCom = result.data;
                    }
                })
            },
            searchServcWorkVoucher: function (id) {
                let self = this;
                let postData = {};
                postData.reqVoucherId = id;
                servcDelivApi.getServcWorkVoucherByReqVoucheId(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkVoucherList = result.data || [];
                        for(let i = 0; i < servcWorkVoucherList.length; i++) {
                            let servcWorkVoucher = servcWorkVoucherList[i];
                            servcWorkVoucher.status = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state).text;
                            let servcReqVoucher = self.servcReqVoucher;
                            servcReqVoucher.status = servcWorkVoucher.status;
                        }
                        self.servcWorkVoucherList = servcWorkVoucherList;
                    }
                })
            },
            returnServcWorkVoucher: function (no) {
                this.$emit('node-click', no);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqVoucherLook.vue